import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import util from '@/lib/util'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css';
Vue.use(MintUI)

Vue.config.productionTip = false;
Vue.prototype.$util = util;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
